import BenefitsService from "@/service/BenefitsService";
import MenuRightSerivce from "@/service/MenuRightService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Benefits } from "@/model/Benefits";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Paginate from "vuejs-paginate";
import benefitsValidationObj from "./S080600-BenefitsValidation.js";
import Settings from "../../../constants/Settings.js";
var benefitsDataValidationObj = new benefitsValidationObj();
export default {
  name: "Benefit",
  mounted() {
    benefitsDataValidationObj.benefitValidation();
    this.assignRights();
    this.getAllStaffGrade();
    this.resetBenefitData();
    this.init();
    this.getAllBenefits();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_BenefitPlan,
    Settings: Settings,
    dictEnum: dictEnum,
    benefits: new Benefits(),
    isEditMode: false,
    benefitList: [],
    staffGradeList: [],
    selectAllBenefit: false,
    selectAllStaffGrade: false,
    tempBenefitModel: new Benefits(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".benefit-table table thead").height();
      var pagginationHeight = $(".paggination-benefit").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllBenefits() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await BenefitsService.getAllBenefitsByPagination(obj);
      if (response.data.IsSuccess) {
        self.benefitList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllStaffGrade() {
      const obj = {};
      const response = await StaffEmploymentService.getAllStaffgrades(obj);
      if (response.data.IsSuccess) {
        this.staffGradeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getBenefitDetail() {
      var self = this;
      const obj = {
        planCode: self.tempBenefitModel.PlanCode,
      };
      const response = await BenefitsService.getBenefitDetail(obj);
      if (response.data.IsSuccess) {
        this.benefits = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllBenefitRecord: function () {
      var self = this;
      var IsSelected = self.selectAllBenefit;
      self.benefitList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleBenefitPopup: function () {
      var arrayList = [];
      var self = this;
      self.benefitList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteBenefitModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleBenefit() {
      var arrayList = [];
      var self = this;
      $('#deleteBenefitModel').modal('hide');
      self.benefitList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        benefitsList: arrayList,
      };
      const response = await BenefitsService.deleteBenefit(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetBenefitData();
        self.init();
        await self.getAllBenefits();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnBenefitSelect: function (model) {
      this.tempBenefitModel = model;
    },
    addBenefit: function () {
      var self = this;
      $('#benefitModel').modal('show');
      self.isEditMode = false;
      self.benefits = new Benefits();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveBenefitData(obj) {
      var self = this;
      const response = await BenefitsService.addBenefit(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetBenefitData();
        self.init();
        await self.getAllBenefits();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditBenefitData(obj) {
      var self = this;
      const response = await BenefitsService.updateBenefit(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetBenefitData();
        self.init();
        await self.getAllBenefits();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveBenefit() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#benefitModel').modal('hide');
          const obj = {
            model: {
              PlanCode: self.benefits.PlanCode,
              CDesc: self.benefits.CDesc,
              EDesc: self.benefits.EDesc,
              StaffGrades: self.benefits.StaffGrades
            }
          };
          if (self.isEditMode) {
            self.EditBenefitData(obj);
          }
          else {
            self.saveBenefitData(obj);
          }
        }
      });
    },
    async editBenefit() {
      var self = this;
      self.isEditMode = true;
      if (self.tempBenefitModel.PlanCode != "") {
        await self.getBenefitDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#benefitModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetBenefitData: function () {
      var self = this;
      self.selectAllBenefit = false;
      self.isEditMode = false;
      self.benefits = new Benefits();
      self.tempBenefitModel = new Benefits();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeBenefitPopup: function () {
      var self = this;
      self.selectAllBenefit = false;
      self.isEditMode = false;
      self.benefits = new Benefits();
      self.tempBenefitModel = new Benefits();
      self.$validator.reset();
      self.vErrors.clear();
      $('#benefitModel').modal('hide');
    },
    selectAllStaffGradeRecord: function () {
      var self = this;
      var IsSelected = self.selectAllStaffGrade;
      self.staffGradeList.forEach(function (val, index) {
        val.IsSelectedStaffGrade = IsSelected;
      });
    },
    onStaffGradeSelect: function () {
      var arrayList = [];
      var self = this;
      self.staffGradeList.forEach(function (key, value) {
        if (key.IsSelectedStaffGrade) {
          arrayList.push(key.StaffGrade);
        }
      });
      if (arrayList.length > 0) {
        if (arrayList.length > 1) {
          self.benefits.StaffGrades = arrayList.join(',');
        }
        else {
          self.benefits.StaffGrades = arrayList[0];
        }
        self.closeStaffGradePopup();
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.WARN_SelectStaffGrade));
      }
    },
    openStaffGrade: function () {
      var self = this;
      $('#staffGradeModel').modal('show');
      self.resetStaffGradePopup();
    },
    closeStaffGradePopup: function () {
      var self = this;
      self.resetStaffGradePopup();
      $('#staffGradeModel').modal('hide');
    },
    resetStaffGradePopup: function () {
      var self = this;
      self.selectAllStaffGrade = false;
      self.staffGradeList.forEach(function (val, index) {
        val.IsSelectedStaffGrade = self.selectAllStaffGrade;
      });
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllBenefits();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080600-Benefits/S080600-Benefits.js